
    /**
    * 【v1.4.0】商家入驻-获取类目（公共接口） -- 【麦赖】
    * 
    **/
    
    // @ts-nocheck
    import request from '../utils/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    export class IReqSupplierCategory_017035 {}
    export class IResSupplierCategory_017035 {
  code: number;
  message: string;
  data: {
    /**
     * 类目编号
     */
    categoryNo: string;
    /**
     * 类目名称
     */
    categoryName: string;
    /**
     * 类目编号路径
     */
    categoryNoPath: string;
    /**
     * 父类目名称
     */
    parentNo: string;
    /**
     * 是否有子节点：0-否 1-是
     */
    hasChild: number;
  }[];
}
    const http: Serve<IReqSupplierCategory_017035, IResSupplierCategory_017035> = (data?) =>  request({
      method: 'GET',
      url: '/supplier/category/0',
      params: data
    }) 
    export default http